import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import SignUp from './SignUp';
import Dashboard from './dashboard/Dashboard';
import Members from './members/Members';
import MemberDetail from './members/MemberDetail';
import Subscriptions from './subscriptions/Subscriptions';
import Scores from './scores/Scores';
import ScoreRegister from './scores/ScoreRegister';
import ScoreLogs from './scoreLogs/ScoreLogs';
import Cognitive from './cognitive/Cognitive';
import CognitiveLogs from './cognitiveLogs/CognitiveLogs';
import Notices from './notices/Notices';
import NoticeRegister from './notices/NoticeRegister';
import Settings from './settings/Settings';
import AdminSettings from './adminSettings/AdminSettings';

function AdminRouter() {

  return (
    <Routes>
      <Route path="/" element={<Login/>}/>
      <Route path="/signup" element={<SignUp/>}/>
      <Route path="/dashboard" element={<Dashboard/>}/>
      <Route path="/members" element={<Members/>}/>
      <Route path="/members/:name" element={<MemberDetail/>}/>
      <Route path="/subscriptions" element={<Subscriptions/>}/>
      <Route path="/scores" element={<Scores/>}/>
      <Route path="/scores/register" element={<ScoreRegister/>}/>
      <Route path="/scores/:scoreId/edit" element={<ScoreRegister/>}/>
      <Route path="/score-logs" element={<ScoreLogs/>}/>
      <Route path="/cognitive" element={<Cognitive/>}/>
      <Route path="/cognitive-logs" element={<CognitiveLogs/>}/>
      <Route path="/notices" element={<Notices/>}/>
      <Route path="/notices/register" element={<NoticeRegister/>}/>
      <Route path="/notices/:noticeId/edit" element={<NoticeRegister/>}/>
      <Route path="/settings" element={<Settings/>}/>
      <Route path="/admin-settings" element={<AdminSettings/>}/>
    </Routes>
  );
}

export default AdminRouter;
